import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static values = { url: String }

  dragStart(event) {
    this.draggedItem = event.target.closest("[data-sortable-target='item']")
    this.draggedItem.classList.add("opacity-50")
    event.dataTransfer.effectAllowed = "move"
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const target = event.target.closest("[data-sortable-target='item']")
    if (!target || target === this.draggedItem) return

    const rect = target.getBoundingClientRect()
    const midY = rect.top + rect.height / 2

    if (event.clientY < midY) {
      target.parentNode.insertBefore(this.draggedItem, target)
    } else {
      target.parentNode.insertBefore(this.draggedItem, target.nextSibling)
    }
  }

  dragEnd(event) {
    this.draggedItem.classList.remove("opacity-50")
    this.saveOrder()
  }

  async saveOrder() {
    const ids = this.itemTargets.map(item => item.dataset.stageId)
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token
        },
        body: JSON.stringify({ stage_ids: ids })
      })

      this.showToast(response.ok ? "Orden actualizado" : "Error al actualizar orden", !response.ok)
    } catch (e) {
      this.showToast("Error al actualizar orden", true)
    }
  }

  showToast(message, isError = false) {
    const existing = document.getElementById("sortable-toast")
    if (existing) existing.remove()

    const toast = document.createElement("div")
    toast.id = "sortable-toast"
    toast.className = `fixed bottom-6 right-6 z-50 px-4 py-3 rounded-lg shadow-lg text-sm font-medium transition-all duration-300 ${
      isError ? "bg-red-600 text-white" : "bg-gray-800 text-white"
    }`
    toast.textContent = message
    document.body.appendChild(toast)

    setTimeout(() => {
      toast.style.opacity = "0"
      setTimeout(() => toast.remove(), 300)
    }, 2000)
  }
}
